import React from 'react';
import { Heart, Code } from 'lucide-react';

function Footer() {
    return (
        <footer className="footer">
            <div className="footer-content">
                <p className="footer-main">
                    © 2025 <strong>Cooksy</strong> - Built with <Heart className="footer-icon" size={16} /> 
                </p>
                <p className="footer-tech">
                    <Code className="footer-icon" size={16} />
                    Made with React.js & TheMealDB API
                </p>
            </div>
        </footer>
    );
}

export default Footer;